import { render } from "./ProviderProduct.vue?vue&type=template&id=33d9f73e&scoped=true"
import script from "./ProviderProduct.vue?vue&type=script&lang=js"
export * from "./ProviderProduct.vue?vue&type=script&lang=js"

import "./ProviderProduct.vue?vue&type=style&index=0&id=33d9f73e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d9f73e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInnerLoading});
